import { render, staticRenderFns } from "./HandleFinishedImg.vue?vue&type=template&id=51495384&scoped=true"
import script from "./HandleFinishedImg.vue?vue&type=script&lang=js"
export * from "./HandleFinishedImg.vue?vue&type=script&lang=js"
import style0 from "./HandleFinishedImg.vue?vue&type=style&index=0&id=51495384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51495384",
  null
  
)

export default component.exports